import { IMAGES, img } from "../config";

export const ROUTES = [
  {
    slug: "dubai-maldives",
    from: "Dubai",
    to: "Maldives",
    fromCity: "dubai",
    toCity: "maldives",
    image: img(IMAGES.maldives, 1400),
    overview:
      "One of the most requested leisure sectors from the Gulf — a direct overwater flight from Dubai's executive terminals to Velana International, timed to connect with your resort's seaplane or speedboat transfer. We source the aircraft through our operator network and coordinate the details around your stay.",
    categories: ["Super Midsize Jets", "Heavy Jets"],
    fromAirports: ["Dubai International (DXB) — executive terminals", "Al Maktoum International (DWC)"],
    toAirports: ["Velana International (MLE), Malé", "Resort seaplane & helipad transfers"],
    why: [
      "Direct private access to the atolls without airline schedules",
      "Arrival timing coordinated with resort transfer windows",
      "Cabins suited to families, staff and leisure baggage",
    ],
    faqs: [
      {
        q: "How much does a Dubai to Maldives charter cost?",
        a: "Every trip is quoted individually — pricing depends on aircraft category, dates, positioning and availability. Share your dates and passenger count and we will come back with sourced options.",
      },
      {
        q: "Which aircraft are typically used on this route?",
        a: "Super midsize and heavy jets are most commonly sourced for this overwater sector, depending on passenger count and baggage. Final aircraft is always subject to availability at the time of booking.",
      },
      {
        q: "Can you coordinate the seaplane transfer to our resort?",
        a: "Yes. We align your arrival with the resort's transfer schedule wherever possible, and can arrange speedboat or domestic connections where seaplanes do not operate.",
      },
      {
        q: "How far in advance should I book?",
        a: "Peak season (December to April) sees strong demand — earlier is better. Short-notice requests are handled case by case, always subject to aircraft availability.",
      },
    ],
  },
  {
    slug: "dubai-london",
    from: "Dubai",
    to: "London",
    fromCity: "dubai",
    toCity: "london",
    image: img(IMAGES.london, 1400),
    overview:
      "A flagship business and leisure corridor between the Gulf and the UK. Departures leave from Dubai's executive terminals and arrive at the London business aviation airport closest to your final destination — Farnborough, Luton or Biggin Hill.",
    categories: ["Heavy Jets"],
    fromAirports: ["Dubai International (DXB) — executive terminals", "Al Maktoum International (DWC)"],
    toAirports: ["Farnborough (FAB)", "London Luton (LTN)", "Biggin Hill (BQH)"],
    why: [
      "Nonstop long-range capability in full-size cabins",
      "Choice of London arrival airports matched to your schedule",
      "Suited to corporate delegations and family travel alike",
    ],
    faqs: [
      {
        q: "Which aircraft can fly Dubai to London nonstop?",
        a: "This sector calls for a heavy, long-range jet — aircraft such as the Global, Gulfstream or Falcon families are typically sourced through our operator network, subject to availability.",
      },
      {
        q: "Which London airport should I arrive at?",
        a: "We recommend the airfield that minimises your ground transfer — Farnborough, Luton and Biggin Hill are the most used — subject to slots and operating hours.",
      },
      {
        q: "How much does this route cost?",
        a: "We do not publish fixed prices. Each charter is sourced and quoted individually based on aircraft, dates and availability at the time of enquiry.",
      },
      {
        q: "Can the aircraft wait in London for my return?",
        a: "It can, subject to parking availability and cost — often a one-way with a separately sourced return is more efficient. We present both options where relevant.",
      },
    ],
  },
  {
    slug: "dubai-mumbai",
    from: "Dubai",
    to: "Mumbai",
    fromCity: "dubai",
    toCity: "mumbai",
    image: img(IMAGES.mumbai, 1400),
    overview:
      "A high-frequency business corridor linking the Gulf with India's financial capital. Private departures from Dubai arrive at Mumbai's general aviation facilities, with helicopter connections available from Juhu for the city.",
    categories: ["Midsize Jets", "Super Midsize Jets"],
    fromAirports: ["Dubai International (DXB) — executive terminals", "Al Maktoum International (DWC)"],
    toAirports: ["Chhatrapati Shivaji Maharaj International (BOM) — GA terminal", "Juhu Aerodrome (helicopters)"],
    why: [
      "Schedule around meetings, not airline timetables",
      "Dedicated terminals at both ends for fast, discreet processing",
      "Same-day return options for single-day business trips",
    ],
    faqs: [
      {
        q: "Which aircraft suit the Dubai–Mumbai sector?",
        a: "Midsize and super midsize jets are the typical choice for this distance; heavy jets are sourced for larger parties. The final aircraft depends on availability at booking.",
      },
      {
        q: "Can I do a same-day return?",
        a: "Yes, same-day returns are common on this corridor. Crew duty limits apply, and we plan the schedule with the operator accordingly.",
      },
      {
        q: "What does Dubai to Mumbai charter pricing look like?",
        a: "Every charter is quoted individually — there are no fixed prices. Send your dates and passenger numbers and we will source options from the operator network.",
      },
      {
        q: "Are Indian landing permits required?",
        a: "Foreign-registered aircraft require Indian landing permits, which the operator arranges with lead time. We manage this coordination as part of your enquiry.",
      },
    ],
  },
  {
    slug: "delhi-dubai",
    from: "Delhi",
    to: "Dubai",
    fromCity: "delhi",
    toCity: "dubai",
    image: img(IMAGES.dubai, 1400),
    overview:
      "Connecting India's capital with the Gulf's commercial hub. Departures operate from Delhi's general aviation terminal with arrivals through Dubai's executive terminals — a corridor we arrange for business, government-adjacent and family travel.",
    categories: ["Midsize Jets", "Super Midsize Jets"],
    fromAirports: ["Indira Gandhi International (DEL) — GA terminal"],
    toAirports: ["Dubai International (DXB) — executive terminals", "Al Maktoum International (DWC)"],
    why: [
      "Direct access between the two commercial capitals on your schedule",
      "Dedicated terminal processing at both ends",
      "Onward helicopter and ground connections across the UAE",
    ],
    faqs: [
      {
        q: "Which aircraft are used between Delhi and Dubai?",
        a: "Midsize and super midsize jets typically serve this sector comfortably; larger groups move to heavy jets. Aircraft are sourced per trip, subject to availability.",
      },
      {
        q: "How early should I enquire?",
        a: "As early as practical — permit lead times apply for some operators. We can also handle short-notice requests case by case, subject to availability.",
      },
      {
        q: "What is the price of a Delhi to Dubai charter?",
        a: "We quote every trip individually rather than publishing fixed prices. Share your requirements and we will return sourced options.",
      },
      {
        q: "Can you arrange onward travel within the UAE?",
        a: "Yes — helicopter transfers, ground transport and onward charters to other Emirates or the wider Gulf can be coordinated through our network.",
      },
    ],
  },
  {
    slug: "mumbai-dubai",
    from: "Mumbai",
    to: "Dubai",
    fromCity: "mumbai",
    toCity: "dubai",
    image: img(IMAGES.heroTarmac, 1400),
    overview:
      "The westbound leg of one of our busiest corridors. Private departures from Mumbai's general aviation terminal arrive at Dubai's executive terminals, with helicopter transfers available onward across the city and the Emirates.",
    categories: ["Midsize Jets", "Super Midsize Jets"],
    fromAirports: ["Chhatrapati Shivaji Maharaj International (BOM) — GA terminal"],
    toAirports: ["Dubai International (DXB) — executive terminals", "Al Maktoum International (DWC)"],
    why: [
      "Depart Mumbai on your schedule, arrive through a private terminal",
      "Suited to business delegations and family travel",
      "Onward connections across the Gulf and to Europe",
    ],
    faqs: [
      {
        q: "Which aircraft typically fly Mumbai to Dubai?",
        a: "Midsize and super midsize jets are the usual fit; heavy jets for larger parties. The specific aircraft is always subject to availability when you book.",
      },
      {
        q: "How much does it cost to charter from Mumbai to Dubai?",
        a: "There are no fixed prices — each trip is sourced and quoted individually. Send your dates and we will return options from the operator network.",
      },
      {
        q: "Can I arrange a helicopter transfer on arrival in Dubai?",
        a: "Yes, helicopter transfers to city helipads and resorts can be arranged through our operator network, subject to landing permissions.",
      },
      {
        q: "Do you handle the return leg as well?",
        a: "Yes — most clients book this as a round trip. We quote each itinerary as a whole and can hold the aircraft or re-source the return, whichever is more efficient.",
      },
    ],
  },
];
